const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<figure class="u-space-block-1">
  <pre><code class="language-`);
                this.echo(this.env.getFilter('escape').traceableCallable(2, this.source)(...[this.env, (context.has(`name`) ? context.get(`name`) : null), `html`, null, true]));
                this.echo(`">`);
                this.echo(this.env.getFilter('escape').traceableCallable(2, this.source)(...[this.env, (context.has(`content`) ? context.get(`content`) : null), `html`, null, true]));
                this.echo(`</code></pre>
  <figcaption><code>language-`);
                this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`name`) ? context.get(`name`) : null), `html`, null, true]));
                this.echo(`</code></figcaption>
</figure>
`);
            }

            getTemplateName() {
                return `ebdc0428af1b20689bb3999abf8d16a5a3b860030febcd6fd364269398fff6c0`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `ebdc0428af1b20689bb3999abf8d16a5a3b860030febcd6fd364269398fff6c0`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'ebdc0428af1b20689bb3999abf8d16a5a3b860030febcd6fd364269398fff6c0');

let template = env.loadTemplate('ebdc0428af1b20689bb3999abf8d16a5a3b860030febcd6fd364269398fff6c0');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/prism/demo/sample.twig", args: context }
     );
     return rendered;;
};